//import services from './services.js';
import { GetERP_OrderById } from '@api/orderApi.js';
import NProgress from 'nprogress';
import { lg, cloneDeep, util, isCorrectVal, isDate } from 'utils';
import { MAP_LIST } from '$http';
import $http from '$http';

//组件
import { GetT_HardwareByPage, MAP_STATUS_LIST, MAP_SIZE_LIST } from '@api/hardWareApi';
import areaSelect from 'area-select';
import waitPayOrderInfo from '@pages/Order/components/waitPayOrderInfo/index.vue';

export default {
    //mixins: [services],
    components: {
        areaSelect: areaSelect,
        waitPayOrderInfo
    },
    data() {
        return {
            formInline: {
                user: '',
                region: ''
            },
            lists: [],
            sels: [], //列表选中列
            SaleCheckView: false,
            pageSizes: [10, 20, 50],
            loading2: false,
            statusList: MAP_STATUS_LIST,
            sizeList: MAP_SIZE_LIST,
            intentProject: MAP_LIST.INTENT_PROJECT,
            choiceProjectType: [],
            query: this.getQueryParam()
        }
    },

    watch: {
        '$route' (to, from) {
            if (this.$route.path == '/Order/waitPayOrderList') {
                this.getDataList();
            }
        }
    },
    methods: {
        getQueryParam() {
            return cloneDeep({
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: 1,
                pageSize: 10,
                total: 0,
                orderBy: "",
                c_name: "",
                orderCode: "",
                agentName: "",
                projectType: ""
            });
        },
        //分页选定行
        handleSizeChange: function(val) {
            this.query.pageSize = val;
            this.getDataList();
        },
        //分页监听dd页面
        handleCurrentChange: function(val) {
            this.query.pageIndex = val;
            this.getDataList();
        },
        getDataList() {
            this.lists = [];
            this.loading2 = true; //拼命加载中显示
            //POST /api/Order/WaitOrderListByPage
            $http.get('api/Order/WaitOrderListByPage', this.query).then(res => {
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                util.doResult(this, res, () => {
                    this.query.total = Cnt;
                    this.loading2 = false; //拼命加载中隐
                    this.lists = Data;
                });
            });
        },
        //查询
        onQuerySubmit() {
            this.query.pageIndex = 1;
            this.query.projectType = this.choiceProjectType.join(",");
            this.getDataList();
        },
        //重置查询条件
        onQueryClean: function(formQuery) {
            util.resetFormQueryParam(formQuery);
            this.getDataList();
        },
        handleView(item) {
            this.$refs.refWaitPayOrderInfo.show({
                id: item.OrderId,
                isUpdate: false
            });
        },
        updateFn(item) {
            this.$refs.refWaitPayOrderInfo.show({
                id: item.OrderId,
                isUpdate: true
            });
        }
    },
    created() {
        this.getDataList();
    }
};


// WEBPACK FOOTER //
// ./src/pages/Order/waitPayOrderList/vm.js